import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "planning-tutorial-msg-3",
  "use": "planning-tutorial-msg-3-usage",
  "viewBox": "0 0 57 41",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 57 41\" id=\"planning-tutorial-msg-3\"><path fill=\"#C5C5C5\" d=\"M.798 2.975q-.135-.008-.27-.017l-.053.837-.168.118 4.91 7.037.82-.573-4.425-6.34c22.963 1.777 40.89 14.093 53.826 36.99l.87-.492C43.513 17.885 25.822 5.42 3.272 3.18l5.58-1.93-.328-.945zm.655.832.16.23C1.23 4.007.85 3.98.465 3.957l.01-.162.474-.33.16.46.34-.118zm-.655-.832-.016.006.167.49.172-.124.326.467 1.82-.63q-1.23-.122-2.475-.203z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol